function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { utils as utils_exports, DEFAULTS, registerButton, TypedEvent, AbstractButton, AbstractConfigurablePlugin, events as events_exports$1, PSVError, AbstractComponent, CONSTANTS as constants_exports } from '../core/index.module.js';

/*!
 * PhotoSphereViewer.GalleryPlugin 5.6.0
 * @copyright 2024 Damien "Mistic" Sorel
 * @licence MIT (https://opensource.org/licenses/MIT)
 */
var __defProp = Object.defineProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};

// src/events.ts
var events_exports = {};
__export(events_exports, {
  HideGalleryEvent: function HideGalleryEvent() {
    return _HideGalleryEvent;
  },
  ShowGalleryEvent: function ShowGalleryEvent() {
    return _ShowGalleryEvent2;
  }
});
var _ShowGalleryEvent = /*#__PURE__*/function (_TypedEvent) {
  _inherits(_ShowGalleryEvent, _TypedEvent);
  var _super = _createSuper(_ShowGalleryEvent);
  /** @internal */
  function _ShowGalleryEvent() {
    _classCallCheck(this, _ShowGalleryEvent);
    return _super.call(this, _ShowGalleryEvent.type);
  }
  return _createClass(_ShowGalleryEvent);
}(TypedEvent);
_ShowGalleryEvent.type = "show-gallery";
var _ShowGalleryEvent2 = _ShowGalleryEvent;
var _HideGalleryEvent = /*#__PURE__*/function (_TypedEvent2) {
  _inherits(_HideGalleryEvent, _TypedEvent2);
  var _super2 = _createSuper(_HideGalleryEvent);
  /** @internal */
  function _HideGalleryEvent() {
    _classCallCheck(this, _HideGalleryEvent);
    return _super2.call(this, _ShowGalleryEvent2.type);
  }
  return _createClass(_HideGalleryEvent);
}(TypedEvent);
_HideGalleryEvent.type = "hide-gallery";

// src/icons/gallery.svg
var gallery_default = '<svg viewBox="185 115 330 330" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M186.7 326.7V163.3c0-15 8.3-23.3 23.3-23.3h210c15 0 23.3 8.3 23.3 23.3v163.4c0 15-8.3 23.3-23.3 23.3H210c-15 0-23.3-8.3-23.3-23.3zm70 70v-23.4H420c30.2 0 46.7-16.4 46.7-46.6V210H490c15 0 23.3 8.3 23.3 23.3v163.4c0 15-8.3 23.3-23.3 23.3H280c-15 0-23.3-8.3-23.3-23.3zm-23.8-105H397l-40-50.4-26.7 29.7-44.3-54.5zm106.7-76c9.6 0 17.8-7.8 17.8-17.2a18 18 0 0 0-17.8-17.8c-9.4 0-17.2 8.2-17.2 17.8 0 9.4 7.8 17.2 17.2 17.2z"/><!--Created by Wolf B\xF6se from the Noun Project--></svg>';

// src/GalleryButton.ts
var GalleryButton = /*#__PURE__*/function (_AbstractButton) {
  _inherits(GalleryButton, _AbstractButton);
  var _super3 = _createSuper(GalleryButton);
  /**
   * @param {PSV.components.Navbar} navbar
   */
  function GalleryButton(navbar) {
    var _this;
    _classCallCheck(this, GalleryButton);
    _this = _super3.call(this, navbar, {
      className: "psv-gallery-button",
      hoverScale: true,
      collapsable: true,
      tabbable: true,
      icon: gallery_default
    });
    _this.plugin = _this.viewer.getPlugin("gallery");
    if (_this.plugin) {
      _this.plugin.addEventListener(_ShowGalleryEvent2.type, _assertThisInitialized(_this));
      _this.plugin.addEventListener(_HideGalleryEvent.type, _assertThisInitialized(_this));
    }
    return _this;
  }
  _createClass(GalleryButton, [{
    key: "destroy",
    value: function destroy() {
      if (this.plugin) {
        this.plugin.removeEventListener(_ShowGalleryEvent2.type, this);
        this.plugin.removeEventListener(_HideGalleryEvent.type, this);
      }
      _get(_getPrototypeOf(GalleryButton.prototype), "destroy", this).call(this);
    }
    /**
     * @internal
     */
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e instanceof _ShowGalleryEvent2) {
        this.toggleActive(true);
      } else if (e instanceof _HideGalleryEvent) {
        this.toggleActive(false);
      }
    }
  }, {
    key: "isSupported",
    value: function isSupported() {
      return !!this.plugin;
    }
  }, {
    key: "onClick",
    value: function onClick() {
      this.plugin.toggle();
    }
  }]);
  return GalleryButton;
}(AbstractButton);
GalleryButton.id = "gallery";
var GALLERY_ITEM_DATA = "psvGalleryItem";
var GALLERY_ITEM_DATA_KEY = utils_exports.dasherize(GALLERY_ITEM_DATA);
var ACTIVE_CLASS = "psv-gallery-item--active";
var ITEMS_TEMPLATE = function ITEMS_TEMPLATE(items, size) {
  return "\n".concat(items.map(function (item) {
    return "\n<div class=\"psv-gallery-item\" data-".concat(GALLERY_ITEM_DATA_KEY, "=\"").concat(item.id, "\" style=\"width:").concat(size.width, "px; aspect-ratio:").concat(size.width / size.height, ";\">\n  ").concat(item.name ? "<div class=\"psv-gallery-item-title\"><span>".concat(item.name, "</span></div>") : "", "\n  <svg class=\"psv-gallery-item-thumb\" viewBox=\"0 0 200 200\" preserveAspectRatio=\"xMidYMid slice\"><use href=\"#psvGalleryBlankIcon\"></use></svg>\n  ").concat(item.thumbnail ? "<div class=\"psv-gallery-item-thumb\" data-src=\"".concat(item.thumbnail, "\"></div>") : "", "\n</div>\n");
  }).join(""), "\n");
};

// src/icons/blank.svg
var blank_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">\n  <defs>\n    <symbol id="psvGalleryBlankIcon" viewBox="0 0 200 200">\n      <rect x="0" y="0" width="200" height="200" fill="#666"/>\n      <g transform="scale(0.25) translate(25 20) " fill="#eee">\n        <path d="M376 220.61c-85.84 0-155.39 69.56-155.39 155.39 0 85.84 69.56 155.39 155.39 155.39 85.84 0 155.39-69.56 155.39-155.39 0-85.84-69.56-155.39-155.39-155.39zm0 300.92c-80.41 0-145.53-65.12-145.53-145.53S295.59 230.47 376 230.47 521.53 295.59 521.53 376 456.41 521.53 376 521.53z"/>\n        <path d="M467.27 300.03H284.74a18.21 18.21 0 0 0-18.25 18.25v115.43a18.21 18.21 0 0 0 18.25 18.26h182.53a18.21 18.21 0 0 0 18.25-18.26V318.28a18.2 18.2 0 0 0-18.25-18.25zm-190.91 18.25a8.64 8.64 0 0 1 8.39-8.38h182.53a8.64 8.64 0 0 1 8.38 8.38V413l-44.89-35.52c-.49-.5-.99-.5-1.48-.99h-2.46c-.5 0-1 0-1.48.5l-37.5 21.2-43.9-58.7-.5-.5s0-.48-.49-.48c0 0-.49 0-.49-.5-.49 0-.49-.49-.99-.49-.49 0-.49 0-.98-.49H337.53c-.5 0-.5.5-.99.5h-.49l-.5.48s-.48 0-.48.5l-58.7 65.12zM467.27 442.1H284.74a8.64 8.64 0 0 1-8.39-8.38v-15.3l63.15-68.07 42.92 57.22 1.48 1.48h.49c.5.5 1.48.5 1.97.5H388.83l38.47-21.72 46.37 36.5c.5.5 1.49 1 1.98 1v8.88c0 3.95-3.45 7.9-8.38 7.9z"/>\n        <path d="M429.77 333.58a13.81 13.81 0 1 1-27.63 0 13.81 13.81 0 0 1 27.63 0"/>\n      </g>\n    </symbol>\n  </defs>\n</svg>';

// src/GalleryComponent.ts
var GalleryComponent = /*#__PURE__*/function (_AbstractComponent) {
  _inherits(GalleryComponent, _AbstractComponent);
  var _super4 = _createSuper(GalleryComponent);
  function GalleryComponent(plugin, viewer) {
    var _this2;
    _classCallCheck(this, GalleryComponent);
    _this2 = _super4.call(this, viewer, {
      className: "psv-gallery ".concat(constants_exports.CAPTURE_EVENTS_CLASS)
    });
    _this2.plugin = plugin;
    _this2.state = {
      visible: true,
      mousedown: false,
      initMouse: null,
      mouse: null,
      itemMargin: null,
      breakpoint: null
    };
    _this2.container.innerHTML = blank_default;
    _this2.container.querySelector("svg").style.display = "none";
    var closeBtn = document.createElement("div");
    closeBtn.className = "psv-panel-close-button";
    closeBtn.innerHTML = constants_exports.ICONS.close;
    _this2.container.appendChild(closeBtn);
    _this2.items = document.createElement("div");
    _this2.items.className = "psv-gallery-container";
    _this2.container.appendChild(_this2.items);
    _this2.state.itemMargin = parseInt(utils_exports.getStyleProperty(_this2.items, "padding-left"), 10);
    _this2.state.breakpoint = parseInt(utils_exports.getStyleProperty(_this2.container, "--psv-gallery-breakpoint"), 10);
    _this2.observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.intersectionRatio > 0) {
          var element = entry.target;
          element.style.backgroundImage = "url(\"".concat(element.dataset.src, "\")");
          delete element.dataset.src;
          _this2.observer.unobserve(entry.target);
        }
      });
    }, {
      root: _this2.viewer.container
    });
    _this2.items.addEventListener("wheel", _assertThisInitialized(_this2));
    _this2.items.addEventListener("mousedown", _assertThisInitialized(_this2));
    _this2.items.addEventListener("mousemove", _assertThisInitialized(_this2));
    _this2.items.addEventListener("click", _assertThisInitialized(_this2));
    window.addEventListener("mouseup", _assertThisInitialized(_this2));
    closeBtn.addEventListener("click", function () {
      return _this2.plugin.hide();
    });
    _this2.hide();
    return _this2;
  }
  _createClass(GalleryComponent, [{
    key: "destroy",
    value: function destroy() {
      window.removeEventListener("mouseup", this);
      this.observer.disconnect();
      _get(_getPrototypeOf(GalleryComponent.prototype), "destroy", this).call(this);
    }
    /**
     * @internal
     */
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      var isAboveBreakpoint = window.innerWidth > this.state.breakpoint;
      switch (e.type) {
        case "wheel":
          {
            if (isAboveBreakpoint) {
              var evt = e;
              var scrollAmount = this.plugin.config.thumbnailSize.width + this.state.itemMargin;
              this.items.scrollLeft += evt.deltaY / Math.abs(evt.deltaY) * scrollAmount;
              e.preventDefault();
            }
            break;
          }
        case "mousedown":
          this.state.mousedown = true;
          if (isAboveBreakpoint) {
            this.state.initMouse = e.clientX;
          } else {
            this.state.initMouse = e.clientY;
          }
          this.state.mouse = this.state.initMouse;
          break;
        case "mousemove":
          if (this.state.mousedown) {
            if (isAboveBreakpoint) {
              var delta = this.state.mouse - e.clientX;
              this.items.scrollLeft += delta;
              this.state.mouse = e.clientX;
            } else {
              var _delta = this.state.mouse - e.clientY;
              this.items.scrollTop += _delta;
              this.state.mouse = e.clientY;
            }
          }
          break;
        case "mouseup":
          this.state.mousedown = false;
          this.state.mouse = null;
          e.preventDefault();
          break;
        case "click":
          {
            var currentMouse = isAboveBreakpoint ? e.clientX : e.clientY;
            if (Math.abs(this.state.initMouse - currentMouse) < 10) {
              var item = utils_exports.getClosest(e.target, "[data-".concat(GALLERY_ITEM_DATA_KEY, "]"));
              if (item) {
                this.plugin.__click(item.dataset[GALLERY_ITEM_DATA]);
              }
            }
            break;
          }
      }
    }
  }, {
    key: "show",
    value: function show() {
      this.container.classList.add("psv-gallery--open");
      this.state.visible = true;
    }
  }, {
    key: "hide",
    value: function hide() {
      this.container.classList.remove("psv-gallery--open");
      this.state.visible = false;
    }
  }, {
    key: "setItems",
    value: function setItems(items) {
      var _this3 = this;
      this.items.innerHTML = ITEMS_TEMPLATE(items, this.plugin.config.thumbnailSize);
      if (this.observer) {
        this.observer.disconnect();
        this.items.querySelectorAll("[data-src]").forEach(function (child) {
          _this3.observer.observe(child);
        });
      }
    }
  }, {
    key: "setActive",
    value: function setActive(id) {
      var currentActive = this.items.querySelector("." + ACTIVE_CLASS);
      currentActive === null || currentActive === void 0 ? void 0 : currentActive.classList.remove(ACTIVE_CLASS);
      if (id) {
        var nextActive = this.items.querySelector("[data-".concat(GALLERY_ITEM_DATA_KEY, "=\"").concat(id, "\"]"));
        if (nextActive) {
          nextActive.classList.add(ACTIVE_CLASS);
          this.items.scrollLeft = nextActive.offsetLeft + nextActive.clientWidth / 2 - this.items.clientWidth / 2;
        }
      }
    }
  }]);
  return GalleryComponent;
}(AbstractComponent);

// src/GalleryPlugin.ts
var getConfig = utils_exports.getConfigParser({
  items: [],
  visibleOnLoad: false,
  hideOnClick: true,
  thumbnailSize: {
    width: 200,
    height: 100
  }
});
var GalleryPlugin = /*#__PURE__*/function (_AbstractConfigurable) {
  _inherits(GalleryPlugin, _AbstractConfigurable);
  var _super5 = _createSuper(GalleryPlugin);
  function GalleryPlugin(viewer, config) {
    var _this4;
    _classCallCheck(this, GalleryPlugin);
    _this4 = _super5.call(this, viewer, config);
    _this4.items = [];
    _this4.gallery = new GalleryComponent(_assertThisInitialized(_this4), _this4.viewer);
    return _this4;
  }
  /**
   * @internal
   */
  _createClass(GalleryPlugin, [{
    key: "init",
    value: function init() {
      var _this5 = this;
      _get(_getPrototypeOf(GalleryPlugin.prototype), "init", this).call(this);
      utils_exports.checkStylesheet(this.viewer.container, "gallery-plugin");
      this.viewer.addEventListener(events_exports$1.PanoramaLoadedEvent.type, this);
      this.viewer.addEventListener(events_exports$1.ShowPanelEvent.type, this);
      if (this.config.visibleOnLoad) {
        this.viewer.addEventListener(events_exports$1.ReadyEvent.type, function () {
          _this5.show();
        }, {
          once: true
        });
      }
      this.setItems(this.config.items);
      delete this.config.items;
      setTimeout(function () {
        return _this5.__updateButton();
      });
    }
    /**
     * @internal
     */
  }, {
    key: "destroy",
    value: function destroy() {
      this.viewer.removeEventListener(events_exports$1.PanoramaLoadedEvent.type, this);
      this.viewer.removeEventListener(events_exports$1.ShowPanelEvent.type, this);
      this.gallery.destroy();
      _get(_getPrototypeOf(GalleryPlugin.prototype), "destroy", this).call(this);
    }
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      _get(_getPrototypeOf(GalleryPlugin.prototype), "setOptions", this).call(this, options);
      if (options.thumbnailSize) {
        this.gallery.setItems(this.items);
      }
    }
    /**
     * @internal
     */
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e instanceof events_exports$1.PanoramaLoadedEvent) {
        var item = this.items.find(function (i) {
          return utils_exports.deepEqual(i.panorama, e.data.panorama);
        });
        this.currentId = item === null || item === void 0 ? void 0 : item.id;
        this.gallery.setActive(this.currentId);
      } else if (e instanceof events_exports$1.ShowPanelEvent) {
        this.gallery.isVisible() && this.hide();
      }
    }
    /**
     * Shows the gallery
     */
  }, {
    key: "show",
    value: function show() {
      this.dispatchEvent(new _ShowGalleryEvent2());
      return this.gallery.show();
    }
    /**
     * Hides the carousem
     */
  }, {
    key: "hide",
    value: function hide() {
      this.dispatchEvent(new _HideGalleryEvent());
      return this.gallery.hide();
    }
    /**
     * Hides or shows the gallery
     */
  }, {
    key: "toggle",
    value: function toggle() {
      if (this.gallery.isVisible()) {
        this.hide();
      } else {
        this.show();
      }
    }
    /**
     * Sets the list of items
     * @param items
     * @param [handler] function that will be called when an item is clicked instead of the default behavior
     * @throws {@link PSVError} if the configuration is invalid
     */
  }, {
    key: "setItems",
    value: function setItems(items, handler) {
      var _this6 = this;
      if (!items) {
        items = [];
      } else {
        items.forEach(function (item, i) {
          if (!item.id) {
            throw new PSVError("Item ".concat(i, " has no \"id\"."));
          }
          if (!item.panorama) {
            throw new PSVError("Item ".concat(item.id, " has no \"panorama\"."));
          }
        });
      }
      this.handler = handler;
      this.items = items.map(function (item) {
        return _objectSpread(_objectSpread({}, item), {}, {
          id: "".concat(item.id)
        });
      });
      this.gallery.setItems(this.items);
      if (this.currentId) {
        var item = this.items.find(function (i) {
          return i.id === _this6.currentId;
        });
        this.currentId = item === null || item === void 0 ? void 0 : item.id;
        this.gallery.setActive(this.currentId);
      }
      this.__updateButton();
    }
    /**
     * @internal
     */
  }, {
    key: "__click",
    value: function __click(id) {
      if (id === this.currentId) {
        return;
      }
      if (this.handler) {
        this.handler(id);
      } else {
        var item = this.items.find(function (i) {
          return i.id === id;
        });
        this.viewer.setPanorama(item.panorama, _objectSpread({
          caption: item.name
        }, item.options));
      }
      this.currentId = id;
      this.gallery.setActive(id);
      if (this.config.hideOnClick) {
        this.hide();
      }
    }
  }, {
    key: "__updateButton",
    value: function __updateButton() {
      var _this$viewer$navbar$g;
      (_this$viewer$navbar$g = this.viewer.navbar.getButton(GalleryButton.id, false)) === null || _this$viewer$navbar$g === void 0 ? void 0 : _this$viewer$navbar$g.toggle(this.items.length > 0);
    }
  }]);
  return GalleryPlugin;
}(AbstractConfigurablePlugin);
GalleryPlugin.id = "gallery";
GalleryPlugin.VERSION = "5.6.0";
GalleryPlugin.configParser = getConfig;
GalleryPlugin.readonlyOptions = ["visibleOnLoad", "items"];

// src/index.ts
DEFAULTS.lang[GalleryButton.id] = "Gallery";
registerButton(GalleryButton, "caption:left");
export { GalleryPlugin, events_exports as events };
//# sourceMappingURL=index.module.js.map
